import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Ticket, TicketList, User } from '../../_shared/models';
import {
  TicketService,
  LoadingService,
  UserService,
  AuthenticationService
} from '../../_shared/services';

@Component({
  selector: 'app-my-tickets',
  templateUrl: './my-tickets.component.html',
  styleUrls: [
    '../../../assets/css/core-navbar.css',
    '../_css-ticket/ticket-content.css',
    './my-tickets.component.css'
  ]
})
export class MyTicketsComponent implements OnInit {
  private tickets: Ticket[];
  private hasRemainingTickets: boolean;
  private current_user: User;
  public selectedTicket: Ticket = null;
  private isClient = false;
  private skip: number = 0;
  private limit: number = 10;

  private filterOptions = ['Division Tickets', 'Not Taken Tickets'];

  private param: string;
  public currentUrlPath: string = '/ticketing/mytickets';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ticketService: TicketService,
    private loadingService: LoadingService,
    private userService: UserService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.authenticationService.userInfo.subscribe(userInfo => {
      this.current_user = userInfo;
      if (userInfo.current_role !== null) {
        this.selectedTicket = null;
        this.getMyTickets();
      }
    });

    // subscribe to param changes
    this.route.paramMap.subscribe(params => {
      this.param = params.get('id');
      if (this.tickets) {
        this.selectedTicket = null;
        this.selectTicketFromParam();
      }
      this.load(false);
    });
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }

  refetchTicket(data: any) {
    this.skip = data;
    this.getMyTickets();
    this.selectedTicket = null;
  }

  getMyTickets() {
    let ticketList: TicketList;

    this.ticketService
      .getMyTickets(
        this.current_user.current_role.division_id,
        this.current_user.current_role.role_id,
        this.skip,
        this.limit
      )
      .finally(() => {
        if (this.skip == 0) {
          this.tickets = ticketList.tickets;
        } else {
          for (let ticket of ticketList.tickets) {
            this.tickets.push(ticket);
          }
        }
        this.hasRemainingTickets = ticketList.has_remaining_data;
        this.selectTicketFromParam();
      })
      .subscribe(res => (ticketList = res.data));
  }

  selectTicketFromParam() {
    let isTicketInvalid = true;
    for (let item of this.tickets) {
      if (item.ticket_id === this.param) {
        isTicketInvalid = false;
        this.ticketService.getSelectedTicket(this.param).subscribe(res => {
          this.selectedTicket = res.data;
        });
      }
    }
    if (isTicketInvalid && this.param !== null) {
      this.router.navigate(['/not-found']);
    }
  }

  selectTicket(ticket: Ticket) {
    // this.loadDetails = true;
    this.selectedTicket = ticket;
    console.log('seltick: ', this.selectedTicket);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/ticket/my-tickets/my-tickets.component.ts